import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/static/css/share.css'
import { Popup } from 'vant';
// import { Message} from 'element-ui';
import 'animate.css';

// Vue.prototype.$message = Message
import { Toast } from 'vant';

Vue.use(Toast);
Vue.use(Popup);

import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
